import { Box, Icon as MuiIcon, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
interface NoDataComponentProps {
    primary: string;
    primaryProps?: React.ComponentProps<typeof Typography>;
    secondary?: string;
    Icon?: string | SvgIconComponent;
    action?: React.ReactNode;
}

const NoDataComponent: React.FC<NoDataComponentProps> = ({
    primary,
    secondary,
    Icon,
    action,
    primaryProps,
}) => {
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            }}
        >
            <Box maxWidth="sm" p={3}>
                {Icon &&
                    (typeof Icon === 'string' ? (
                        <MuiIcon color="primary" sx={{ fontSize: 64, mb: 2 }}>
                            {Icon}
                        </MuiIcon>
                    ) : (
                        <Icon color="primary" sx={{ fontSize: 64, mb: 2 }} />
                    ))}
                <Typography
                    variant="headlineLarge"
                    gutterBottom
                    {...primaryProps}
                >
                    {primary}
                </Typography>

                <Typography variant="bodyLarge" sx={{ mb: 3 }}>
                    {secondary}
                </Typography>

                {action}
            </Box>
        </Box>
    );
};

export default NoDataComponent;
